export default __webpack_public_path__ + "static/media/Group3.94ea2316.svg";